<div class="dialog-wrap">
  <h1 mat-dialog-title class="dialog-title">
    Schedule a call with our team
    <button type="button" (click)="close()" class="btn text-size-15">
      <craft-icon class="svg-icon" name="general--close-md"></craft-icon>
    </button>
  </h1>
  <craft-hubspot-form
    hubspotFormId="c7b5eaad-bb86-4612-beba-bf0da90c7286"
    hubspotPortalId="7090790"
    class="mt-20"
  ></craft-hubspot-form>
</div>
